module.exports = __webpack_public_path__ + "img/huibiao.093bd141.png";